export default {
  home: {
    minute: "分",
    price_info:
      "最初の{mianfei}分間は無料です。24時間の最大料金は{currencyName}{fengding}です。モバイルバッテリーはどの{appName}ステーションでも返却可能です。",
    price_info_0: "USB Type-C、Lightningケーブル内蔵。",
    price_info_1:
      "もし{pOvertimeDay}日以内にモバイルバッテリーが返却されない場合、デポジット金額で買い取られたものとみなされます。",
    price_info_2:
      "レンタルした場所と同じ場所での返却を推奨します。アプリをダウンロードするか、モバイルバッテリー裏面のQRコードをスキャンして、すべての{appName}設置場所をご確認ください。",
    feature_1: "全タイプのケーブル内蔵：iPhone、Type-C",
    feature_2: "どこのステーションでも返却可能",
    feature_3: "ワイヤレス充電対応",
    tips_1: "デポジット{currencyName}{yajin}は、レンタル終了時に返金されます。",
    tips_2:
      "チャージしたデポジット{currencyName}{yajin}はレンタルに利用でき、利用後は返金可能です。",
    tips_3:
      "現在の残高は{currencyName}{myyue}です。この残高はレンタルに直接利用できます。",
    submit: "レンタル開始",
    borrow: "借りる",
    msg_fail_title: "エラー",
    msg_fail_content: "レンタルに失敗しました。もう一度お試しください。",
    msg_rentcount: "現在、未完了の注文が{zujieNum}件あります。",
    goborrow: "充電する！！！",
    nearby: "近くのステーションを見る",
    preauth: "事前承認",
    nearbyvenues: "近くの施設",
    borrow_tips:
      "クレジットカード支払いの安全性 / プライバシーポリシー / 利用規約",
    company_address:
      "Energo Solar d.o.o Sarajevo Kolodvorska 12 Bosna i Hercegovina",
    company_phone: "(+81)924414056   (+81)924414056",
    company_email: "pluspercent-support@3rrr-hd.jp",
    company_id: "ID番号: 4203203380006",
    company_vat: "VAT番号: 203203380006",
    shop_desc_text: "どのステーションでも返却可能です。",
    available_rental: "レンタル可能",
    select_battery_type: "バッテリーの種類を選択してください。",
    rechargeable_battery: "充電式バッテリー",
    fast_charging_battery: "急速充電バッテリー",
    rental_period: "レンタル期間",
    usage_fee: "利用料金",
    standard_powerbank: "標準モバイルバッテリー",
    fast_charge_powerbank: "急速充電モバイルバッテリー",
    deposit: "デポジット金額",
    deposit_return: "(返却時に精算)",
    deposit_includes: "デポジット {currencyName}{yajin} を含みます"
  },
  login: {
    welcome: "{appname}へようこそ",
    code_title: "認証",
    phone_number: "電話番号",
    verification_email: "メールアドレスを入力してください",
    verification_code: "認証コードを入力してください",
    captcha_code: "コード",
    send_code: "コードを送信",
    login: "ログイン",
    agree: "ログインすることで、以下に同意したことになります：",
    readme: "利用規約",
    msg_fail_login: "ログインに失敗しました",
    msg_success_login: "ログイン成功",
    msg_fail_user: "ユーザー情報の取得に失敗しました。再試行しますか？",
    sign_in_with: "サインイン：",
    no_sms: "メッセージが届かない場合",
    retry: "再送",
    email: "メールアドレス"
  },
  confirm: {
    deletecard: "カードを削除",
    addcard: "カード情報を入力",
    title: "支払い確認",
    paynow: "今すぐ支払う",
    SMSConfirm:
      "携帯電話に届いたメッセージに従って支払いを行い、確認ボタンを押して続行してください。",
    pay_label: "金額",
    auth_label: "事前承認",
    price_tips:
      "残高は申請により払い戻し可能です。入金確認まで1〜5営業日かかる場合があります。",
    auth_tips:
      "事前承認額 {0}{1} が必須です。実際のレンタル料金はモバイルバッテリー返却時に精算されます。",
    pay_type: "支払い方法を選択してください",
    submit: "支払いを確定する",
    msg_loading: "読み込み中...",
    msg_fail_title: "警告",
    msg_fail_payment: "デポジットの支払いに失敗しました",
    msg_fail_order: "レンタル注文の作成に失敗しました",
    msg_fail_support: "このシステムはサポートされていません",
    msg_fail_confirm: "確認",
    msg_fail_retry: "再試行",
    msg_fail_cancel: "キャンセル",
    selected_item: "選択内容"
  },
  mine: {
    title: "ユーザープロフィール",
    wallet: "マイウォレット",
    balance: "残高",
    deposit: "デポジット",
    wallet_in: "チャージ",
    wallet_out: "払い戻し",
    wallet_log: "ウォレット履歴",
    rental_history: "レンタル履歴",
    payment_title: "支払い方法",
    home_title: "ホーム",
    download_app: "アプリをダウンロード",
    settings: "設定",
    help: "ヘルプ",
    logout: "ログアウト",
    login_tips: "ログインしてください",
    msg_fail_title: "エラー",
    msg_fail_update: "変更に失敗しました。もう一度お試しください。",
    msg_loading: "読み込み中...",
    msg_fail_user: "ユーザー情報の取得に失敗しました。再試行しますか？",
    edit_profile: "プロフィール編集",
    join_us: "加盟店募集",
    join_us_details: "あなたの店舗にプラパのステーションを設置しませんか"
  },
  msg: {
    appoffline: "アプリはまだ起動していません。お待ちください。",
    deletecard: "本当にこのカードを削除しますか？",
    no_phone: "電話番号は必須です",
    loading: "読み込み中...",
    title: "ヒント",
    success: "操作成功",
    error: "不明なエラーが発生しました。後でもう一度お試しください。",
    roleerror: "権限が不足しています。管理者に問い合わせてください。",
    neterror: "ネットワーク接続に失敗しました。後でもう一度お試しください。",
    confirm: "確認",
    retry: "再試行",
    cancel: "キャンセル",
    title_fail: "警告",
    vieworder: "注文を見る",
    success_payment: "支払い完了",
    success_buy: "購入完了",
    fail_payment: "支払い失敗",
    keyword: "キーワード",
    ispayorder: "支払いが完了しているか確認してください",
    unpay: "未払い",
    yespay: "支払い済み",
    notopen: "未定"
  },
  result: {
    tips:
      "注文や他のステーションの場所を確認するには、アプリをダウンロードしてください。",
    download: "アプリをダウンロード",
    title: "レンタル確定",
    gotit: "OK",
    price_plan: "料金プラン",
    msg_success: "レンタルに成功しました",
    msg_tips_loading: "緑に光るスロットをご確認ください",
    msg_result_loading: "支払い結果を確認しています...",
    msg_fail_confirm: "確認",
    btn_usage: "使用上の注意",
    btn_return: "返却時の注意",
    deposit: "デポジット",
    msg_fail_content: "リクエストに失敗しました。もう一度お試しください。",
    price_label: "1時間あたり",
    price_info:
      "最初の{mianfei}分間は無料。1日の最大料金は{ccurrency}{fengding}。利用料が{ccurrency}{yajin}に達するとデポジットから自動的に差し引かれます。",
    tips_1: "画像の通り、No.{number}のモバイルバッテリーをお取りください。",
    tips_2:
      "ケーブルを整理し、[下向き矢印]のマークがある面をスロットに差し込んでください。",
    msg_note_usage:
      "このモバイルバッテリーには3種類のケーブルが付属しています。お使いの機器に合わせて選択してください。",
    msg_note_return:
      "ケーブルを整理し、[下向き矢印]のマークがある面をスロットに差し込んでください。",
    return_info:
      "返却時は、ケーブルをきれいに整え、金属チップのある面を空いているスロットの奥までしっかり差し込んで固定してください。",
    download_tips:
      "モバイルバッテリーをレンタルするには、以下のオプションから選択してください。",
    return_map: "MAPに戻る",
    download_app: "アプリDL",
    download_tips1: "アプリならもっと便利に",
    download_tips2: "・スポッ卜検索 ·利用履歷",
    download_tips3: "・次回はラクにレンタル!",
    download_tips4: "・ク一ポン利用でお得に!",
    popping_up: "排出中..."
  },
  result_msg: {
    loading: "読み込み中...",
    refresh: "更新"
  },
  order: {
    title: "レンタル履歴",
    in_use: "利用中",
    ended: "終了",
    msg_error: "リクエスト失敗",
    order_number: "No.",
    order_details: "注文詳細",
    order_zj_shop: "レンタル場所",
    order_zj_time: "レンタル日時",
    order_gh_shop: "返却場所",
    order_gh_time: "返却日時",
    order_use_time: "利用時間",
    order_amount: "合計金額",
    not_on_rent: "未レンタル",
    renting: "レンタル中",
    undone: "未完了",
    returned: "返却済み",
    questions: "お問い合わせ",
    timeout_to_return: "返却期限切れ",
    suspended_for_billing: "請求一時停止中"
  },
  order_item: {
    order_number: "No.",
    venue_rented: "貸出場所",
    time_rented: "貸出日時",
    venue_returned: "返却場所",
    time_returned: "返却日時",
    charge_standard: "料金体系",
    charge_standard_info:
      "1時間あたり {pJifei} {pCurrency} (最初の{pMian}分は無料)",
    rent_occurred: "レンタル発生",
    returned: "返却済み",
    unreturned: "未返却",
    type_0: "未完了",
    type_1: "レンタル中",
    type_2: "キャンセル済み",
    type_3: "返却済み",
    type_4: "エラー発生",
    type_5: "時間超過",
    min: "分",
    payment: "支払い",
    unpay: "未払い"
  },
  setting: {
    title: "設定",
    lang: "言語"
  },
  help: {
    title: "よくある質問",
    rentals: "レンタルについて",
    venues: "設置場所について",
    payments: "支払いについて"
  },
  wallet_in: {
    title: "残高チャージ",
    price_label: "チャージ金額",
    price_placeholder: "チャージ金額を入力してください",
    balance: "現在の残高",
    price_auto: "支払い金額を選択",
    price_tips:
      "残高は申請により払い戻し可能です。入金確認まで1〜5営業日かかる場合があります。",
    submit: "送信",
    loading: "読み込み中...",
    paying: "支払いページへ移動中...",
    msg_title: "ヒント",
    msg_fail_order: "チャージ注文の作成に失敗しました",
    msg_fail_payment: "チャージ支払いの開始に失敗しました",
    msg_fail_retry: "再試行"
  },
  wallet_out: {
    title: "払い戻し",
    price_label: "払い戻し金額",
    price_placeholder: "払い戻し金額を入力してください",
    balance: "現在の残高",
    balance_all: "全額払い戻し",
    deposit: "デポジット",
    deposit_tips:
      "未完了のレンタル注文があります。デポジット Ksh{pyajin} は返金できません。",
    submit: "送信",
    apply: "申請",
    confirm: "確認",
    loading: "読み込み中...",
    msg_fail_price: "払い戻し金額が正しくありません",
    msg_fail_balance: "払い戻し金額は現在の残高を超えることはできません",
    msg_fail_submit: "必須項目をすべて入力してください",
    msg_title: "エラー",
    msg_success_content: "返金成功",
    confirmtitle: "ヒント",
    confirmcontent:
      "現在のウォレットは現金引き出しに対応していません。手動での返金処理のため、連絡先情報を入力してください。",
    payee_name: "受取人名",
    payee_bankcard: "銀行口座番号",
    payee_phone: "電話番号",
    cancelText: "キャンセル",
    confirmText: "再申請"
  },
  map: {
    在线: "営業中",
    离线: "休業中",
    title: "近くのステーション",
    result_msg: "近くにステーションが見つかりませんでした",
    msg_title: "エラー",
    no_support:
      "申し訳ありません！お使いのブラウザは位置情報サービスに対応していません",
    my_position: "現在地",
    distance: "距離：",
    shop_time: "営業時間",
    free: "貸出可能数",
    return: "返却可能数",
    shop_title: "施設詳細",
    address: "住所",
    go_here: "ここへ行く",
    nav_help: "ヘルプ",
    nav_search: "検索",
    locate: "位置特定",
    history: "履歴",
    account: "マイアカウント",
    scan: "スキャン"
  },
  scanQr: {
    NotAllowedError: "カメラへのアクセスを許可する必要があります",
    NotFoundError: "このデバイスにはカメラがありません",
    NotSupportedError: "セキュリティコンテキストが必要です（HTTPS, localhost）",
    NotReadableError: "カメラは使用中です",
    OverconstrainedError: "カメラのインストールが適切ではありません",
    StreamApiNotSupportedError:
      "このブラウザはストリーミングAPIをサポートしていません"
  },
  payment: {
    payment_title: "支払い方法",
    pay_type: "カード情報を追加してください",
    add_payment_card: "支払いカードを追加",
    add_payment: "支払いを追加"
  },
  shop: {
    title: "近くのステーション",
    search_station: "ステーションを検索",
    search_station_tips: "ステーション名を入力してください",
    shop_power_banks: "貸出可能数",
    shop_empty_slots: "返却可能数",
    shop_address: "住所",
    shop_business_hours: "営業時間",
    shop_directions_station: "ステーションへの経路",
    shop_scan_qrcode: "QRコードをスキャン",
    fast_charging_power_banks: "急速充電バッテリー",
    ordinary_power_bank: "通常バッテリー",
    returnable: "返却可能"
  },
  time: {
    days: "日",
    hours: "時間",
    minutes: "分",
    day: "日",
    hour: "時間",
    minute: "分"
  }
};
